export default __webpack_public_path__ + "static/media/landing-Word-Objeto3.b4063fc7.webp";